import { useScopedField } from "@ngt/forms-core";
import { useMemo } from "react";

/**
 * Hook to determine if the current registration is a custom registration
 * based on whether registrationAffiliation has a value
 */
export const useIsCustomRegistration = () => {
    const {state: { value: registrationAffiliation }} = useScopedField<number>("registrationAffiliation", { value: true });

    const isCustomRegistration = useMemo(() => {
        return registrationAffiliation !== null && registrationAffiliation !== undefined;
    }, [registrationAffiliation]);

    return isCustomRegistration;
}
